import { observer } from "mobx-react-lite";
import { CustomDropdown } from "../../../components/dropdown/Dropdown";
import { Country } from "../../../apis/types";
import { TCText } from "../../../components/tcText/TCText";

type Props = {
  placeholder?: string;
  value: Country | null;
  onChange: (value: Country | null) => void;
  options: Country[];
};

export const SelectCountryDropDown: React.FC<Props> = observer(
  ({ placeholder, value, onChange, options }) => {
    const selectedCountryTemplate = (
      option: Country | null,
      props: any | null
    ) => {
      if (option) {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img
              alt={option.name}
              src={option.imageUrl}
              className={`mr-2 flag flag-${option.code.toLowerCase()}`}
              style={{ width: "18px" }}
            />
            <TCText value={option.name} />
          </div>
        );
      }
      return <TCText value={placeholder ?? "Select a Country"} />;
    };

    const countryOptionTemplate = (option: Country) => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}>
          <img
            alt={option.name}
            src={option.imageUrl}
            className={`mr-2 flag flag-${option.code.toLowerCase()}`}
            style={{ width: "15px" }}
          />
          <TCText style={{ width: 10 }} value={option.name} />
        </div>
      );
    };

    return (
      <CustomDropdown
        value={value}
        onChange={(v) => {
          onChange(v);
        }}
        options={options}
        optionLabel="name"
        placeholder={placeholder ?? "Select a Country"}
        filter
        filterDelay={400}
        valueTemplate={selectedCountryTemplate}
        itemTemplate={countryOptionTemplate}
        className="w-full md:w-14rem"
        style={{ width: "90%", alignSelf: "center" }}
      />
    );
  }
);
